import {Controller} from "stimulus"

export default class extends Controller {

    static targets = [
    ]

    initialize() {
        const heightViewport = window.innerHeight
        const container = document.querySelector(".js-sidebar")

        window.addEventListener('scroll', (e) => {
            // this.setSize()

            if (window.scrollY >= heightViewport / 2) {
                container.classList.add('is-active')
            } else if (window.scrollY <= heightViewport / 2) {
                container.classList.remove('is-active')
            }
        })


        /*window.addEventListener('resize', () => {
            this.setSize()
        })*/

       /* if (this.intersectionObserver()) {
            this.intersectionObserver()
        }*/
    }

    setSize() {
        const items = this.contentTarget.querySelectorAll('div')
        let sizeContent = 0

        items.forEach(item => {
            const size = item.offsetHeight

            if (sizeContent < size) {
                sizeContent = size
            }
        })

        this.contentTarget.style.height = `${sizeContent}px`

    }

    intersectionObserver() {
        const sections = document.querySelectorAll('.section-tab')
        const items = this.contentTarget.querySelectorAll('div')
        const options = {
            root: null,
            rootMargin: '0px',
            threshold: 1
        }

        //OBSERVER
        this.observer = new IntersectionObserver(isVisible, options)

        //OBSERVE
        sections.forEach(target => {
            this.observer.observe(target);
        })

        //CALLBACK
        function isVisible(entries) {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // const index = entry.target.getAttribute('data-index')

                    /*items.forEach(item => {
                        item.classList.remove('is-active')
                    })

                    items[index].classList.add('is-active')*/
                }
            })
        }
    }

}